import { ContainerModule } from 'inversify';
import { DataroomTenant } from '@dataroom/tenant/DataroomTenant';
import { DIUploadTypes } from '@/dataroom/app/DI/FileUpload/types';
import FormDataFileUploadDispatcherFactory from '@/dataroom/app/DI/FileUpload/FormDataFileUploadDispatcher';
import type {
  IFormDataFileUploadDispatcherFactory,
  IFormDataFileUploadDispatcherFactoryMethod,
} from '@/dataroom/app/DI/FileUpload/FormDataFileUploadDispatcher/interfaces';

export const FormDataFileUploadModule = new ContainerModule(({ bind }) => {
  bind<IFormDataFileUploadDispatcherFactory>(DIUploadTypes.FormDataFileUploadDispatcherFactory)
    .to(FormDataFileUploadDispatcherFactory)
    .inSingletonScope();

  bind<IFormDataFileUploadDispatcherFactoryMethod>(DIUploadTypes.FormDataFileUploadDispatcher)
    .toFactory(({ get }) =>
      (tenantCode?: DataroomTenant) =>
        get<IFormDataFileUploadDispatcherFactory>(
          DIUploadTypes.FormDataFileUploadDispatcherFactory,
        ).create(tenantCode),
    );
});
